import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordPlaceholder: {
    id: 'login.form.password.placeholder',
    defaultMessage: 'Enter password',
  },
  passwordLabel: {
    id: 'login.form.password.label',
    defaultMessage: 'Password',
  },
});
